import { Injectable } from '@angular/core';
import { ProductShotcutEntry, ProductShotcuts } from './product-shortcut.model';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import { CmsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class ProductShortcutService {
  protected productShortcuts$ = new BehaviorSubject<ProductShotcuts>({ shortcuts: [] });

  constructor(private cmsService: CmsService) {}

  getShorcut() {
    return this.productShortcuts$.asObservable();
  }

  setShorcut(container: ProductShotcuts) {
    this.productShortcuts$.next(container);
  }

  normalize(data: any): Observable<ProductShotcuts> {
    const shortcuts$: Observable<ProductShotcutEntry>[] =
      (data.shortcuts || ``).split(` `)?.map((shortcutID: string) => this.cmsService.getComponentData(shortcutID)) ||
      [];

    return combineLatest(shortcuts$).pipe(
      map((dirtProductShotcutEntrys: any[]) => {
        let shortcuts: ProductShotcutEntry[] = [];

        shortcuts = dirtProductShotcutEntrys.map((shortcut: any) => ({
          icon: shortcut?.icon || undefined,
          label: shortcut?.label,
          targetUID: shortcut?.targetUID,
          visible: true,
        }));

        return {
          shortcuts,
        };
      }),
    );
  }
}
